const actionTypes = {
  SET_PRODUCT_ADD_MODAL: 'sendDetailSetProductAddModal',
  SET_TRANSACTION_DETAILS: 'sendDetailSetTransactionDetails',
  SET_RECEIVE_STATUS: 'sendDetailSetReceiveStatus',
  DELETE_PRDUCT_LIST: 'sendDetailDeleteProduct_list',
  SET_PRODUCT_LIST: 'sendDetailSendDetailSetProductList',
  SET_OTHER_PRODUCTS: 'sendDetailSetOtherProducts',
  SET_ORIGINAL_OTHER_PRODUCTS: 'sendDetailSetOriginalOtherProducts',
  CLEAR_OTHER_PRODUCTS: 'sendDetailClearOtherProducts',
  SET_OTHER_TOTAL_COUNT: 'sendDetailSetOtherTotalCount',
  SET_OTHER_CURRENT_PAGE: 'sendDetailSetOtherCurrentPage',
  SET_OTHER_PAGE_SIZE: 'sendDetailSetOtherPageSize',
  SET_OHTER_ADD_SUBMIT_MODAL: 'sendDetailSetOhterAddSubmitModal',
  SET_SELECTED_OTHER_PRODUCT: 'sendDetailSetSelectedOtherProduct',
}

export default actionTypes
